import { Stack, Typography, Box } from "@mui/material";
import { CustomButton } from "../ui/CustomButton";
import { CompanyIcon } from "../images/CompanyIcon";

export const EmptyProductListItem = () => {
  return (
    <Stack
      sx={{
        gap: "16px",
        border: "1px solid #D9D9D9",
        padding: "16px",
        borderRadius: "8px",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingBottom: "8px",
          borderBottom: "1px solid #D9D9D9",
        }}
      >
        <Stack gap="4px" direction="row" color="custom" alignItems="center">
          <Typography
            variant="subtitle1"
            color="custom.textDarkBlue"
            fontWeight={500}
          >
            Campaign name
          </Typography>

          <Box
            sx={{
              width: "4px",
              height: "4px",
              borderRadius: "50%",
              backgroundColor: "#A9A9A9",
            }}
          />

          <Typography variant="subtitle1" color="#A9A9A9" fontWeight={500}>
            Company
          </Typography>
        </Stack>

        <Typography
          variant="body1"
          color="custom.textDarkBlue"
          fontWeight={500}
          sx={{ display: "flex", gap: "4px" }}
        >
          Last update:
          <Typography component="span">--</Typography>
        </Typography>
      </Stack>

      <Typography variant="body1" color="custom.textDarkBlue" fontWeight={500}>
        Critical Job Titles
      </Typography>

      <Stack
        sx={{
          width: { xs: "100%", lg: "70%" },
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        <Typography variant="body1" color="#4C545B">
          No job titles marked yet
        </Typography>
      </Stack>

      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" gap="4px" alignItems="center">
          <CompanyIcon width="34px" height="34px" />
          <Typography
            variant="body1"
            color="custom.textDarkBlue"
            fontWeight={500}
          >
            0 accounts attached
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Stack direction="row" gap="8px" minWidth="340px">
            <CustomButton
              variant="contained"
              fullWidth
              type="button"
              customColor="#1C3C6C"
              sx={{ height: "38px" }}
              disabled={true}
            >
              View accounts
            </CustomButton>
            <CustomButton
              variant="outlined"
              customColor="#FFFFFF"
              textColor="#1D3E70"
              fullWidth
              type="button"
              sx={{ height: "38px", borderColor: "#1D3E70" }}
              disabled={true}
            >
              Сampaign details
            </CustomButton>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
